<template>
  <div class="flex flex-col items-center text-center">
    <h2 class="text-[#041A21] font-bold text-[18px]">Voucher Generated</h2>
    <p class="text-[#516166]mt-2 text-[14px]">Your voucher has been generated and can be sent to your email.</p>
    <div class="w-full mt-4">
      <RewardInfoCard
        :current-savings="currentSavings"
        :savings-goal="savingsGoal"
        :reward-amount="rewardAmount"
        :progress="progress"
        :minimum-threshold-met="minimumThresholdMet"
      />
    </div>
    <div class="flex gap-3 w-full mt-6">
      <Button variant="outline" class="flex-1 h-12 text-base font-semibold" @click="emit('cancel')">Cancel</Button>
      <Button
        class="flex-1 h-12 text-base font-semibold bg-teal-700 hover:bg-teal-800"
        :disabled="isSending"
        @click="emit('sendEmail')"
      >
        <LayupSpinner v-if="isSending" :size="4" />
        <span>Send via email</span>
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import LayupSpinner from '@/components/common/LayupSpinner.vue';
import { Button } from '@/components/ui/button';
import RewardInfoCard from './RewardInfoCard.vue';

withDefaults(
  defineProps<{
    currentSavings: number;
    savingsGoal: number;
    rewardAmount: number;
    progress: number;
    isSending: boolean;
    minimumThresholdMet?: boolean;
  }>(),
  { minimumThresholdMet: true },
);

const emit = defineEmits<{
  (e: 'cancel'): void;
  (e: 'sendEmail'): void;
}>();
</script>
